import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrg } from '../../context/OrgContext';

const DemoPage: React.FC = () => {
  const navigate = useNavigate();
  const { selectOrganization, loading } = useOrg();

  useEffect(() => {
    const loadDemoCafe = async () => {
      try {
        const demoOrg = await selectOrganization('beanbuzz-demo');

        if (demoOrg) {
          navigate(`/beanbuzz-demo/dashboard`);
        } else {
          navigate('/');
        }
      } catch (error) {
        console.error('Error loading demo cafe:', error);
        navigate('/');
      }
    };

    loadDemoCafe();
  }, [selectOrganization, navigate]);

  return (
    <div className="main-content">
      <div className="loading-container">
        <div className="loading-spinner-container">
          <div className="loading-spinner-text">
            {loading ? 'Loading demo cafe...' : 'Redirecting to demo cafe dashboard...'}
          </div>
          <div className="loading-spinner-element"></div>
        </div>
      </div>
    </div>
  );
};

export default DemoPage; 